import { SxProps, Theme } from '@mui/material';

export const taskEventRootSx = (
  backgroundColor: string,
  borderColor: string,
  isWaiting: boolean
): SxProps<Theme> => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  padding: 0.5,
  backgroundColor,
  border: `1px solid ${borderColor}`,
  borderRadius: 1,
  opacity: isWaiting ? 0.65 : 1,
  cursor: 'pointer',
});

export const titleRowSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.25,
  minWidth: 0,
  py: 0.25,
};

export const recurringIconSx = (color: string): SxProps<Theme> => ({
  fontSize: '0.75rem',
  color,
  flexShrink: 0,
});

export const taskTitleSx = (color: string): SxProps<Theme> => ({
  lineHeight: 1.2,
  color,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const statusChipTextSx = (color: string): SxProps<Theme> => ({
  fontSize: '0.6rem',
  fontWeight: 'bold',
  color,
  lineHeight: 1.2,
});
